import { createContext } from "react";
export const EntertainmentState = createContext();
EntertainmentState.displayName = "EntertainmentState";
